<template>
  <ion-page>
    <master-layout pageTitle="ویرایش اطلاعات ضایعات">
      <ion-card>
        <ion-card-content>
          <Loading :is="!sellReqLoaded" v-if="!sellReqLoaded"></Loading>
          <div v-if="sellReqLoaded">
            <div v-if="sellRequest">
              <div class="table-responsive ">
                <table class="table">
                  <thead>
                  <tr>
                    <th>ضایعات</th>
                    <th>مقدار موجود</th>
                    <th>مقدار</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(item,index) in sellRequest" :key="index">
                    <td>
                      <div  class="custom-control custom-checkbox mb-3 mt-2">
                        <input value="1" autocomplete="off"
                               type="checkbox"
                               @change="addIsChecked(index)"
                               :checked="item.isChecked"
                               class="custom-control-input"
                               :id="'customCheck'+index" name="in_local">
                        &nbsp;<label class="custom-control-label" :for="'customCheck'+index">{{item.title}}</label>
                      </div>
                    </td>
                    <td>
                      {{item.amount}}&nbsp;{{item.unit}}
                    </td>
                    <td>
                      <div>
                        <input :disabled="!item.isChecked" v-model="item.req_amount" type="tel" name="amount" class="form-control">
                      </div>
                    </td>
                  </tr>
                  </tbody>

                </table>
              </div>
              <ion-button @click="submitRequest" color="success" type="submit" expand="full">ویرایش درخواست</ion-button>

            </div>
            <div v-if="error" class="alert alert-danger">
              {{error}}
            </div>
          </div>
        </ion-card-content>
      </ion-card>
    </master-layout>
  </ion-page>
</template>

<script>
import {
  IonCard, IonCardTitle, IonCardContent, IonPage
} from "@ionic/vue";
import {mapActions} from "vuex";
import Loading from "@/components/Loading";
import AliSelect from "@/components/aliSelect";
import AliAjaxSelect from "@/components/aliAjaxSelect";
import AjaxForm from "@/components/AjaxForm";
import {showSystemNoti} from "@/shared/helper";

export default {
  data()
  {
    return {
      id:null,
      sellReqLoaded: false,
      sellRequest:null,
      error:null,
    };
  },
  async created()
  {
    this.id = this.$route.params.id;
    const result = await this.getWastageSellReqForEdit(this.id);
    if (result)
    {
      if (result.ok)
      {
        this.sellReqLoaded = true;
        this.sellRequest = result.w_items;
      }
      else
      {
        this.sellReqLoaded = true;
        this.error = result.error
      }
    }
    else
    {
      this.sellReqLoaded = true;
      this.error = 'خطا در برقراری ارتباط با سرور'
    }
  },
  components: {
    AjaxForm,
    Loading,
    AliSelect,
    AliAjaxSelect,
    IonCard, IonCardTitle, IonCardContent, IonPage
  },
  methods: {
    ...mapActions("app", {
      getWastageSellReqForEdit: 'getWastageSellReqForEdit',
      editWastageSellRequestFunc: 'editWastageSellRequest',
    }),
    async submitRequest()
    {
      const out = [];
      const a_wastage = this.sellRequest;
      for (let i = 0; i < a_wastage.length; i++)
      {
        const item = a_wastage[i];
        if (item.isChecked)
        {
          if (item.req_amount )
          {
            if (!isNaN(item.req_amount))
            {
              const out_item = {};
              out_item._id = item._id;
              out_item.amount = item.req_amount;
              out.push(out_item);
            }
            else
              return showSystemNoti('danger','مقادیر درخواستی را باید عدد وارد کنید.');
          }
          else
            return showSystemNoti('danger','مقادیر درخواستی را باید عدد وارد کنید.');
        }
      }
      const end_items = {req_id : this.id,items : out};
      const check = await this.editWastageSellRequestFunc(end_items);
      if (check.ok)
      {
        return showSystemNoti('success',check.message);
      }
      else
        return showSystemNoti('danger',check.error);

    },
    addIsChecked(index)
    {
      const item = this.sellRequest[index];
      item.isChecked = !item.isChecked;
    },
  }
};

</script>

<style scoped>
.h5 {
  font-weight: 900;
  font-size: 15px;
  align-self: center;
  color: #000000b3;
}

</style>